import forge from 'node-forge';

const publicKeyPem = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxP/VJ7xwtFY70z1LJIDYfFmuBR7bCdMCPrf7oOnug8KRKzHoBPoZugzTworc26oegxkbSZYp9b5Pwac8GLVaHXiycWhFAeObTyVdNMmzKm01MSF+KkzbVDVJhMiwMlFCu0W/LGwLkNOfTgod3lbogTGPMNu9VApby77IWM0RZB+Hk7h65SYv5R3Ma9PQwtEoMEah5hKoK7qH1cF0NHObg4x2dmEbq3jflJjErrRCHJq/RxlBwXMDqHYEL++eLVJ1QVM2edO8PtJXMm6HTu88Qzru3JGW4QgymRwYLNl7NMqEMJ1cBYUa6iM3W2MzZVQ9UaE+skTaK2uQjcLGU2u01wIDAQAB
-----END PUBLIC KEY-----
`;

export const encryptJson = (data: unknown) => {
  const json = JSON.stringify(data);

  const byteLength = new TextEncoder().encode(json).length;
  if (byteLength > 245) {
    throw new Error(`JSON size ${byteLength} bytes — too large for RSA`);
  }

  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

  const encrypted = publicKey.encrypt(
    json,
    'RSAES-PKCS1-V1_5'
  );

  return forge.util.encode64(encrypted);
};